export default function AppDownload() {
  return (
    <section className="py-24 bg-gradient-to-r from-[#0A1628] via-[#00A8E8] to-[#E91E63] relative overflow-hidden">
      {/* Floating Shapes */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-64 h-64 bg-white/10 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-white/10 blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
      </div>

      <div className="max-w-5xl mx-auto px-6 text-center relative z-10">
        {/* Icon */}
        <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-3xl flex items-center justify-center mx-auto mb-8">
          <i className="ri-smartphone-line text-4xl text-white"></i>
        </div>

        {/* Headline */}
        <h2 className="text-6xl font-bold text-white mb-6">
          Baixe o VitaUni
        </h2>

        {/* Subheadline */}
        <p className="text-2xl text-white/90 mb-12 max-w-2xl mx-auto">
          Seu cartão digital de benefícios em saúde está no app.
        </p>

        {/* App Download Buttons */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center mb-8">
          <a 
            href="https://play.google.com/store/apps/details?id=br.com.vitauni&hl=pt_BR" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-4 px-10 py-6 bg-white text-gray-900 rounded-2xl hover:bg-gray-100 transition-all shadow-2xl hover:shadow-white/20 hover:scale-105 cursor-pointer group"
          >
            <i className="ri-google-play-fill text-4xl"></i>
            <div className="text-left">
              <div className="text-xs text-gray-600 whitespace-nowrap">Disponível na</div>
              <div className="text-xl font-bold whitespace-nowrap">Google Play</div>
            </div>
            <i className="ri-arrow-right-line text-2xl group-hover:translate-x-1 transition-transform"></i>
          </a>

          <a 
            href="https://apps.apple.com/br/app/vitauni/id6757611955" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-4 px-10 py-6 bg-white text-gray-900 rounded-2xl hover:bg-gray-100 transition-all shadow-2xl hover:shadow-white/20 hover:scale-105 cursor-pointer group"
          >
            <i className="ri-apple-fill text-4xl"></i>
            <div className="text-left">
              <div className="text-xs text-gray-600 whitespace-nowrap">Disponível na</div>
              <div className="text-xl font-bold whitespace-nowrap">App Store</div>
            </div>
            <i className="ri-arrow-right-line text-2xl group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>

        {/* Platform Text */}
        <p className="text-white/80 text-lg">
          Disponível para Android e iOS
        </p>
      </div>
    </section>
  );
}
